





























































import { Vue, Component, Watch } from "@/shared/vuepack";
import { FundingOption } from "@/shared/types";
import { Validator } from "vee-validate";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import PayrollReport from "@/employer/components/reports/PayrollReport.vue";
import PayrollCalendar from "@/employer/components/profile/PayrollCalendar.vue";
import ContributionsFileUpload from "@/employer/components/landing-pages/ContributionsFileUpload.vue";
import PendingContributionsReport from "@/employer/components/reports/PendingContributionsReport.vue";
import { useUserStore } from "@/shared/store/user";
import { useProfileStore } from "@/employer/store/profile";

@Component({
  components: {
    ContributionsNavigation,
    PayrollReport,
    PayrollCalendar,
    ContributionsFileUpload,
    PendingContributionsReport
  }
})
export default class ContributionsHistory extends Vue {
  $validator: Validator;

  userStore = useUserStore();
  profileStore = useProfileStore();

  fundingHistoryOptions = [];
  showPayrollHistoryReport = false;
  showPayrollCalendar = false;
  showContributionsFileUpload = false;
  showPendingContributionsReport = false;

  created () {
    this.profileStore.loadFundingOptionHistory(this.userStore.employerId);
  }

  @Watch("profileStore.fundingOptionHistory")
  fundingOptionHistoryChange () {
     this.profileStore.fundingOptionHistory.forEach(option => {
        switch (option) {
          case FundingOption.BendCalculatePull:
            if (this.fundingOption !== FundingOption.BendCalculatePull) {
              this.fundingHistoryOptions.push({key: "Past Payroll Calendar Dates", value: "PayrollCalendar"});
            }
            this.fundingHistoryOptions.push({key: "Payroll History Reports", value: "PayrollReport"});
            break;
          case FundingOption.ErCalculateBendPull:
            if (this.fundingOption !== FundingOption.ErCalculateBendPull) {
              this.fundingHistoryOptions.push({key: "File Processing History", value: "ContributionsFileUpload"});
              this.fundingHistoryOptions.push({key: "Canceled Pending Contributions", value: "PendingContributionsReport"});
            }
            break;
          case FundingOption.ErCalculateErPush:
            break;
        }
     });
  }

  resetHistorySelection () {
    this.showPayrollHistoryReport = false;
    this.showPayrollCalendar = false;
    this.showContributionsFileUpload = false;
    this.showPendingContributionsReport = false;
  }

  onfundingOptionHistorySelected (v) {
    this.resetHistorySelection();
    if (v === "PayrollReport") {
      this.showPayrollHistoryReport = true;
    }
    if (v === "PayrollCalendar") {
      this.showPayrollCalendar = true;
    }
    if (v === "ContributionsFileUpload") {
      this.showContributionsFileUpload = true;
    }
    if (v === "PendingContributionsReport") {
      this.showPendingContributionsReport = true;
    }
  }

  get hasFundingOptionHistory () {
    return this.fundingHistoryOptions !== null && this.fundingHistoryOptions.length > 0;
  }

  get fundingOption (): FundingOption {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.fundingOption) {
      return this.userStore.currentEmployer.fundingOption;
    }
    return FundingOption.None;
  }

  get isBendCalculatedPayroll () {
    return this.fundingOption === FundingOption.BendCalculatePull;
  }

}
